module.exports = __webpack_public_path__ + "img/telegramm-icon.5ae40c98.svg";